export default "__VITE_ASSET__CTRl$BZh__"